// extracted by mini-css-extract-plugin
module.exports = {"ValidCode":"verification_ValidCode_21LZV"};